import React, { FC } from 'react'
import { DropzoneRootProps } from 'react-dropzone'

type Props = {
  getRootProps: <T extends DropzoneRootProps>(props?: T | undefined) => T
}

const Dropzone: FC<Props> = ({ getRootProps }) => {
  return (
    <div className="chat-input-textarea-dropzone" {...getRootProps()}>
      <span className="fal fa-cloud-arrow-up"></span>
    </div>
  )
}

export default Dropzone
